import client from './client';

import {
  QuestionListOption,
  QuestionListOptionCreate,
  QuestionListOptionUpdate,
} from './questionnaire.types';

// =============================================================================
// API Functions - List Option Management (Admin)
// =============================================================================

export async function createListOption(
  questionnaireId: number,
  questionId: number,
  data: QuestionListOptionCreate,
): Promise<QuestionListOption> {
  const response = await client.post<QuestionListOption>(
    `/questionnaires/${questionnaireId}/questions/${questionId}/options`,
    data,
  );
  return response.data;
}

export async function updateListOption(
  questionnaireId: number,
  questionId: number,
  optionId: number,
  data: QuestionListOptionUpdate,
): Promise<QuestionListOption> {
  const response = await client.put<QuestionListOption>(
    `/questionnaires/${questionnaireId}/questions/${questionId}/options/${optionId}`,
    data,
  );
  return response.data;
}

export async function deleteListOption(
  questionnaireId: number,
  questionId: number,
  optionId: number,
): Promise<void> {
  await client.delete(
    `/questionnaires/${questionnaireId}/questions/${questionId}/options/${optionId}`,
  );
}
